import { api as generatedApi } from "~/gql/generatedApi.generated";
import { availabilityEndpoints } from "~/services/endpoints/availabilityEndpoints";
import { backgroundJobEndpoints } from "~/services/endpoints/backgroundJobEndpoints";
import { carrierEndpoints } from "~/services/endpoints/carrierEndpoints";
import { categoryEndpoints } from "~/services/endpoints/categoryEndpoints";
import { commissionsEndpoints } from "~/services/endpoints/commissionsEndpoints";
import { customerEndpoints } from "~/services/endpoints/customerEndpoints";
import { customerStatementsEndpoints } from "~/services/endpoints/customerStatementsEndpoints";
import { devicesEndpoints } from "~/services/endpoints/devicesEndpoints";
import { duplicateCandidateEndpoints } from "~/services/endpoints/duplicateCandidateEndpoints";
import { emailDomainEndpoints } from "~/services/endpoints/emailDomainEndpoints";
import { emailSendersEndpoints } from "~/services/endpoints/emailSendersEndpoints";
import { emailSmtpEndpoints } from "~/services/endpoints/emailSmtpEndpoints";
import { engageEndpoints } from "~/services/endpoints/engageEndpoints";
import { eventsEndpoints } from "~/services/endpoints/events/eventsEndpoints";
import { featureFlagEndpoints } from "~/services/endpoints/featureFlagEndpoints";
import { fernieAccountingEndpoints } from "~/services/endpoints/fernieAccountingEndpoints";
import { flatChargeTypeEndpoints } from "~/services/endpoints/flatChargeTypeEndpoints";
import { forecastSettingsEndpoints } from "~/services/endpoints/forecastSettingsEndpoints";
import { logisticsLoadEndpoints } from "~/services/endpoints/fulfill/logistics/logisticsLoadEndpoints";
import glAccountsPaginatedApi from "~/services/endpoints/glAccountsPaginatedApi";
import growerBenchmarksEndpoints from "~/services/endpoints/growerBenchmarksEndpoints";
import importSessionsEndpoints from "~/services/endpoints/importSessionsEndpoints";
import inboundDocumentEndpoints from "~/services/endpoints/inboundDocumentEndpoints";
import { integrationEndpoints } from "~/services/endpoints/integrationEndpoints";
import { inventoryEndpoints } from "~/services/endpoints/inventoryEndpoints";
import { invoiceEndpoints } from "~/services/endpoints/invoiceEndpoints";
import { invoicesEndpoints } from "~/services/endpoints/invoicesEndpoints";
import { itemCharacteristicEndpoints } from "~/services/endpoints/itemCharacteristicEndpoints";
import itemProductionMappingEndpoints from "~/services/endpoints/itemProductionMappingEndpoints";
import { itemsEndpoints } from "~/services/endpoints/itemsEndpoints";
import learningEndpoints from "~/services/endpoints/learningEndpoints";
import { loadListEndpoints } from "~/services/endpoints/loadListEndpoints";
import { locationEndpoints } from "~/services/endpoints/locationEndpoints";
import { masterOrdersEndpoints } from "~/services/endpoints/masterOrdersEndpoints";
import { materialEndpoints } from "~/services/endpoints/materialEndpoints";
import { missingDataEndpoints } from "~/services/endpoints/missingDataEndpoints";
import { movementOrderEndpoints } from "~/services/endpoints/movementOrderEndpoints";
import { multiFactorEndpoints } from "~/services/endpoints/multiFactorEndpoints";
import { notificationEndpoints } from "~/services/endpoints/notificationEndpoints";
import { notificationOverridesEndpoints } from "~/services/endpoints/notificationOverridesEndpoints";
import onboardingJourneyEndpoints from "~/services/endpoints/onboardingJourneyEndpoints";
import onboardingUploadApi from "~/services/endpoints/onboardingUploadApi";
import { ordersEndpoints } from "~/services/endpoints/ordersEndpoints";
import { otaEndpoints } from "~/services/endpoints/otaEndpoints";
import { parentCompanyEndpoints } from "~/services/endpoints/parentCompanyEndpoints";
import { portalEndpoints } from "~/services/endpoints/portalEndpoints";
import { priceEndpoints } from "~/services/endpoints/priceEndpoints";
import { pricingPageEndpoints } from "~/services/endpoints/pricingPageEndpoints";
import asyncImportJobEndpoints from "~/services/endpoints/produce/asyncImportJobEndpoints";
import consolidationPreviewEndpoints from "~/services/endpoints/produce/consolidationPreviewEndpoints";
import { consolidationRulesEndpoints } from "~/services/endpoints/produce/consolidationRulesEndpoints";
import hardgoodsAssignmentEndpoints from "~/services/endpoints/produce/hardgoodsAssignmentEndpoints";
import { jobCostEndpoints } from "~/services/endpoints/produce/jobCostEndpoints";
import materialPriceEndpoints from "~/services/endpoints/produce/materialPriceEndpoints";
import { eventsManagementEndpoints } from "~/services/endpoints/produce/productionEventManagement";
import { productionItemEndpoints } from "~/services/endpoints/produce/productionItemEndpoints";
import { productionLotAllocationEndpoints } from "~/services/endpoints/produce/productionLotAllocationEndpoints";
import { productionRecipeEndpoints } from "~/services/endpoints/produce/productionRecipeEndpoints";
import { productionScheduleEndpoints } from "~/services/endpoints/produce/productionScheduleEndpoints";
import { produceSpacePlanningEndpoints } from "~/services/endpoints/produce/productionSpacePlanningEndpoints";
import { produceTriggerEndpoints } from "~/services/endpoints/produce/productionTriggerEndpoints";
import productionYearPlanEndpoints from "~/services/endpoints/produce/productionYearPlanEndpoints";
import { reapplyRecipesEndpoints } from "~/services/endpoints/produce/reapplyRecipesEndpoints";
import { recipeCostEndpoints } from "~/services/endpoints/produce/recipeCostEndpoints";
import { shrinkLossEndpoints } from "~/services/endpoints/produce/shrinkLossEndpoints";
import { siteCostEndpoints } from "~/services/endpoints/produce/siteCostEndpoints";
import { spaceCapacityEndpoints } from "~/services/endpoints/produce/spaceCapacityEndpoints";
import supplierPriceImportEndpoints from "~/services/endpoints/produce/supplierPriceImportEndpoints";
import taskAssignmentEndpoints from "~/services/endpoints/produce/taskAssignmentEndpoints";
import vendorItemAliasEndpoints from "~/services/endpoints/produce/vendorItemAliasEndpoints";
import { programsEndpoints } from "~/services/endpoints/programsEndpoints";
import { rampInvoiceEndpoints } from "~/services/endpoints/rampInvoiceEndpoints";
import { reportsEndpoints } from "~/services/endpoints/reportsEndpoints";
import { allocationTemplateEndpoints } from "~/services/endpoints/restock/allocationTemplateEndpoints";
import { replenishmentRulesEndpoints } from "~/services/endpoints/restock/replenishmentRulesEndpoints";
import { replenishmentSettingEndpoints } from "~/services/endpoints/restock/replenishmentSettingEndpoints";
import { restockDashboardEndpoints } from "~/services/endpoints/restock/restockDashboardEndpoints";
import { restockMetricsEndpoints } from "~/services/endpoints/restock/restockMetricsEndpoints";
import { restockSessionEndpoints } from "~/services/endpoints/restock/restockSessionEndpoints";
import { routeDeliveryScheduleEndpoints } from "~/services/endpoints/routeDeliveryScheduleEndpoints";
import { routeEndpoints } from "~/services/endpoints/routeEndpoints";
import { scheduledInventoryTransferEndpoints } from "~/services/endpoints/scheduledInventoryTransferEndpoints";
import { siteLocationEndpoints } from "~/services/endpoints/siteLocationEndpoints";
import { storeClassEndpoints } from "~/services/endpoints/storeClassEndpoints";
import { tenantEndpoints } from "~/services/endpoints/tenantEndpoints";
import { tenantStripeConnectEndpoints } from "~/services/endpoints/tenantStripeConnectEndpoints";
import { tenantUomEndpoints } from "~/services/endpoints/tenantUomEndpoints";
import { termsEndpoints } from "~/services/endpoints/termsEndpoints";
import { userSettingsEndpoints } from "~/services/endpoints/userSettingsEndpoints";
import { usersEndpoints } from "~/services/endpoints/usersEndpoints";
import { vendorEndpoints } from "~/services/endpoints/vendorEndpoints";
import { vendorPurchaseOrderEndpoints } from "~/services/endpoints/vendorPurchaseOrderEndpoints";
import { verifyEndpoints } from "~/services/endpoints/verifyEndpoints";
import whatsNewEndpoints from "~/services/endpoints/whatsNewEndpoints";
import wsapiImportApi from "~/services/endpoints/wsapiImportApi";
import { wsapiImportEndpoints } from "~/services/endpoints/wsapiImportEndpoints";

const allEndpoints = {
	...allocationTemplateEndpoints,
	...asyncImportJobEndpoints,
	...availabilityEndpoints,
	...backgroundJobEndpoints,
	...growerBenchmarksEndpoints,
	...engageEndpoints,
	...carrierEndpoints,
	...logisticsLoadEndpoints,
	...categoryEndpoints,
	...commissionsEndpoints,
	...consolidationPreviewEndpoints,
	...consolidationRulesEndpoints,
	...customerEndpoints,
	...customerStatementsEndpoints,
	...notificationOverridesEndpoints,
	...devicesEndpoints,
	...otaEndpoints,
	...duplicateCandidateEndpoints,
	...hardgoodsAssignmentEndpoints,
	...emailDomainEndpoints,
	...emailSendersEndpoints,
	...emailSmtpEndpoints,
	...restockDashboardEndpoints,
	...restockMetricsEndpoints,
	...restockSessionEndpoints,
	...eventsEndpoints,
	...eventsManagementEndpoints,
	...featureFlagEndpoints,
	...fernieAccountingEndpoints,
	...flatChargeTypeEndpoints,
	...forecastSettingsEndpoints,
	...importSessionsEndpoints,
	...inboundDocumentEndpoints,
	...integrationEndpoints,
	...inventoryEndpoints,
	...invoiceEndpoints,
	...invoicesEndpoints,
	...itemCharacteristicEndpoints,
	...itemProductionMappingEndpoints,
	...itemsEndpoints,
	...learningEndpoints,
	...loadListEndpoints,
	...locationEndpoints,
	...masterOrdersEndpoints,
	...materialEndpoints,
	...missingDataEndpoints,
	...movementOrderEndpoints,
	...multiFactorEndpoints,
	...notificationEndpoints,
	...onboardingJourneyEndpoints,
	...ordersEndpoints,
	...parentCompanyEndpoints,
	...portalEndpoints,
	...priceEndpoints,
	...pricingPageEndpoints,
	...programsEndpoints,
	...reportsEndpoints,
	...produceSpacePlanningEndpoints,
	...produceTriggerEndpoints,
	...jobCostEndpoints,
	...materialPriceEndpoints,
	...productionItemEndpoints,
	...productionRecipeEndpoints,
	...productionLotAllocationEndpoints,
	...productionScheduleEndpoints,
	...productionYearPlanEndpoints,
	...reapplyRecipesEndpoints,
	...taskAssignmentEndpoints,
	...recipeCostEndpoints,
	...shrinkLossEndpoints,
	...siteCostEndpoints,
	...spaceCapacityEndpoints,
	...supplierPriceImportEndpoints,
	...replenishmentRulesEndpoints,
	...replenishmentSettingEndpoints,
	...routeDeliveryScheduleEndpoints,
	...routeEndpoints,
	...scheduledInventoryTransferEndpoints,
	...siteLocationEndpoints,
	...storeClassEndpoints,
	...tenantEndpoints,
	...tenantStripeConnectEndpoints,
	...tenantUomEndpoints,
	...termsEndpoints,
	...usersEndpoints,
	...userSettingsEndpoints,
	...whatsNewEndpoints,
	...vendorEndpoints,
	...vendorItemAliasEndpoints,
	...vendorPurchaseOrderEndpoints,
	...rampInvoiceEndpoints,
	...verifyEndpoints,
	...wsapiImportEndpoints
};

export const apiEndpoints = generatedApi.enhanceEndpoints({
	addTagTypes: [
		"AccountingIntegrationConfig",
		"FernieQuickBooksLinks",
		"FernieStripeTaxCodeCandidates",
		"QuickBooksLinkJob",
		"Address",
		"AllocationTemplates",
		"AsyncImportJob",
		"Availability",
		"BackgroundJobs",
		"GrowerBenchmarkAccessLog",
		"GrowerBenchmarkCommunities",
		"GrowerBenchmarkFirmProfiles",
		"GrowerBenchmarkFirms",
		"GrowerBenchmarkMetrics",
		"GrowerBenchmarkRetailMonths",
		"GrowerBenchmarkReviews",
		"GrowerBenchmarkSubmissions",
		"Carriers",
		"LoadStopNoticeStatus",
		"FreightQuoteSendStatus",
		"Category",
		"FlatChargeTypes",
		"CommissionConfigs",
		"ConsolidationApplications",
		"ConsolidationPreview",
		"ConsolidationRules",
		"Counts",
		"Customer",
		"CustomerReceivables",
		"CustomerRetailPrices",
		"Contact",
		"CountReasons",
		"CustomerGroups",
		"CustomerTypes",
		"Devices",
		"DeviceLobby",
		"OtaReleases",
		"OtaRollouts",
		"FeatureFlag",
		"FloatingTimeEntries",
		"ForecastSettings",
		"GrowPointStaged",
		"ImportSessions",
		"IntegrationHealth",
		"RevenueRoutingCoverage",
		"InventoryItems",
		"InventoryStockSummary",
		"InventoryTransactions",
		"Invoice",
		"Items",
		"ItemCharacteristics",
		"ItemProductionMappings",
		"JobCosts",
		"Learning",
		"LoadList",
		"RestockDashboardRows",
		"RestockMetrics",
		"RestockSessionKits",
		"RestockSessions",
		"Location",
		"MasterOrders",
		"SiteLocation",
		"SpaceCapacityWindows",
		"SpaceUtilization",
		"StatementPrintBatch",
		"StoreClasses",
		"SupplierPriceImport",
		"SynchronizationIterations",
		"MaterialItemLocationQuantities",
		"MaterialItems",
		"MaterialTransactions",
		"MovementOrderTransactions",
		"Notifications",
		"OnboardingJourney",
		"OrderEaseIntegration",
		"OrderKind",
		"OrderPayments",
		"OrderQuoteDetails",
		"Orders",
		"ParentCompany",
		"PendingTransferOrders",
		"PortalAccount",
		"PortalCart",
		"PortalCatalog",
		"PortalCustomerOrders",
		"PortalCustomerOrderLines",
		"PortalDeliveryDates",
		"PortalFavoritesList",
		"PortalOrders",
		"PortalPrice",
		"PortalRetailPriceHistory",
		"PortalInvoices",
		"PortalSettings",
		"PortalUsers",
		"Price",
		"PricingPage",
		"ProduceTags",
		"ProductionSpaceCategory",
		"ProductionSpaceType",
		"ProductionTrigger",
		"ProductionCatalogs",
		"ProductionCategories",
		"ProductionItems",
		"ProductionJobs",
		"ProductionLotAllocations",
		"ProductionLotOverrideHistory",
		"PendingProductionEntries",
		"ProductionLots",
		"ProductionPlans",
		"ProductionYearPlans",
		"ProductionYearPlanYears",
		"ProductionMaterialEvents",
		"TaskAssignments",
		"TaskEventTypes",
		"TimeEntries",
		"ProductionSpaceEvents",
		"ProductionTaskEvents",
		"ProductionRecipe",
		"Programs",
		"RampConnection",
		"Reports",
		"ReportFolders",
		"ReportCashReceiptsData",
		"ReportCustomerAgingData",
		"ReportCustomerAvgDaysToPayData",
		"ReportCustomerSalesPaymentsCreditsData",
		"ReportDataSources",
		"ReportExecutions",
		"ReportSalesComparisonData",
		"ReportSchedules",
		"ReportTemplates",
		"ReportVersions",
		"ReplenishmentRules",
		"ReplenishmentSettings",
		"RouteDeliveryScheduleConfig",
		"Routes",
		"ScheduledInventoryTransfers",
		"Tenant",
		"TenantStripeConnect",
		"TenantRouteConfig",
		"TenantCarrierConfig",
		"TenantUomNames",
		"Terms",
		"UnallocatedAvailability",
		"UserAppSettings",
		"WhatsNew",
		"UserInvites",
		"Users",
		"Me",
		"MultiFactor",
		"TenantMultiFactorPolicy",
		"InboundDocuments",
		"InboundIntakeSettings",
		"VendorItemAliases",
		"VendorMaterialCosts",
		"VendorPurchaseOrders",
		"RampPurchaseOrderCopy",
		"RampPurchaseOrderInvoices",
		"Vendors",
		"RampVendorLinks",
		"VerifyContainers",
		"VerifyOrderVerification",
		"VerifyPullOrder",
		"WorkerConfig",
		"WsapiImport",
		"CycleCountHistory",
		"CycleCountAssignments",
		"EmailSends",
		"OrderEmailSettings",
		"OrderEmailRecipientRouting",
		"TenantEmailSenders",
		"TenantEmailDomain",
		"TenantSmtpConnection",
		"NotificationSettings",
		"DuplicateCandidate",
		"TextConsents"
	],
	endpoints: allEndpoints
});

// Export all hooks
export const {
	useActivateCategoryMutation,
	useGenerateCustomerStatementRunMutation,
	useGetCustomerNotificationSettingsQuery,
	useGetOrderNotificationSettingsQuery,
	useSendCustomerStatementsMutation,
	useGetCustomerStatementPreviewQuery,
	useGetCustomersStatementDeliveryEffectiveQuery,
	useLazyGetCustomerStatementRunReviewLinesQuery,
	useGetCustomerStatementRunsQuery,
	useLazyGetCustomerStatementRunsQuery,
	useRequestStatementPrintBatchMutation,
	useGetStatementPrintBatchQuery,
	useLazyGetStatementPrintBatchQuery,
	useActivateContainerConfigMutation,
	useActivateCustomerItemMutation,
	useActivateCustomerMutation,
	useActivateItemMutation,
	useActivateMaterialItemMutation,
	useActivateProductionCategoryMutation,
	useActivateProductionItemMutation,
	useActivateProductionLotMutation,
	useActivateProductionMaterialEventMutation,
	useActivateProductionRecipeMutation,
	useActivateProductionSpaceCategoryMutation,
	useActivateProductionSpaceEventMutation,
	useActivateProductionSpaceTypeMutation,
	useActivateProductionTaskEventMutation,
	useActivateProductionTriggerMutation,
	useActivateTaskEventTypeMutation,
	useActivateTermsMutation,
	useAddBlockingRuleLinkedItemsMutation,
	useAddBlockingRuleLinkedLocationsMutation,
	useAddPromotionRuleLinkedItemsMutation,
	useAddPromotionRuleLinkedLocationsMutation,
	useAddBillingAddressMutation,
	useAddCategoryMutation,
	useAddContactMutation,
	useAddCustomerItemMutation,
	useAddCustomerMutation,
	useAddCustomerUpgradeMutation,
	useDeactivateCustomerUpgradeMutation,
	useToggleCustomerUpgradeDefaultMutation,
	useUpdateCustomerUpgradeMutation,
	useAdjustInvoiceMutation,
	useApplyCreditMemoMutation,
	useIssueCreditMemoMutation,
	useAddItemMutation,
	useAddItemCharacteristicMutation,
	useAddItemCharacteristicValueMutation,
	useDeleteItemCharacteristicMutation,
	useDeleteItemCharacteristicValueMutation,
	useUndeleteItemCharacteristicMutation,
	useUndeleteItemCharacteristicValueMutation,
	useUpdateItemCharacteristicMutation,
	useUpdateItemCharacteristicValueMutation,
	useLazyGetItemCharacteristicsQuery,
	useAddLineItemsMutation,
	useAddLineItemsWithPricingMutation,
	useAddMasterLineItemsMutation,
	useAddLocationMutation,
	useAddFlatChargeTypeMutation,
	useAddOrderFlatChargeMutation,
	useAddOrderLineUpgradeMutation,
	useAddPriceGroupMutation,
	useAddProductionLotAsyncImportJobRowsMutation,
	useAddProductionMaterialEventDetailsMutation,
	useAddProductionMaterialEventToCategoryMutation,
	useAddProductionMaterialEventToJobMutation,
	useAddProductionRecipeVariationMutation,
	useAddProductionSpaceEventDetailsMutation,
	useAddProductionSpaceEventToCategoryMutation,
	useAddProductionSpaceEventToJobMutation,
	useAddProductionTaskEventDetailsMutation,
	useAddProductionTaskEventToCategoryMutation,
	useAddTaskAssignmentNoteMutation,
	useAddTermsMutation,
	useMarkProductionJobsDoneMutation,
	useMarkProductionJobsStartedMutation,
	useSetProductionJobNotesMutation,
	useAddWsapiImportEntityMappingMutation,
	useAdjustProductionLotAllocationMutation,
	useAllocateLineItemsMutation,
	useGetTakeSourceLinesQuery,
	useLazyGetTakeSourceLinesQuery,
	useTakeLineItemAllocationsMutation,
	useAllocateProductionLotToOrderLineMutation,
	useApproveProductionLotMutation,
	useBulkAllocateOrdersMutation,
	useRequestBulkOrderDeleteMutation,
	useCancelBulkOrderDeleteJobMutation,
	useCancelProductionLotAllocationMutation,
	useAssignDeviceLocationMutation,
	useAssignMaterialItemToVendorMutation,
	useAttachAvailabilitySessionPhotoMutation,
	useBatchActivateCategoriesMutation,
	useBatchActivateCustomersMutation,
	useBatchActivateItemsMutation,
	useBatchActivatePriceGroupsMutation,
	useBatchCreateDraftProductionLotsMutation,
	useBatchDeactivateProductionLotsMutation,
	useBatchDeleteCustomersMutation,
	useBatchDeleteItemsMutation,
	useBatchDeletePriceGroupsMutation,
	useBatchDeleteSiteLocationsMutation,
	useBatchInactivateCategoriesMutation,
	useBatchInactivateCustomersMutation,
	useBatchInactivateItemsMutation,
	useBatchInactivatePriceGroupsMutation,
	useBatchOverrideProductionJobWeeksMutation,
	useBatchRemoveCategoriesMutation,
	useBatchUpdateProductionRecipeVariationFieldsMutation,
	useBatchUpdateProductionRecipeVariationsMutation,
	useAllocateMutation,
	useCorrectAcknowledgedQuantityMutation,
	useCorrectOrderMutation,
	useCreateAllocationTemplateMutation,
	useDeleteAllocationTemplateMutation,
	useCalculateProductionJobCostsQuery,
	useCalculateRecipeCostQuery,
	useCancelErpLoadListSessionMutation,
	useCancelLaborTaskMutation,
	useCancelTaskMutation,
	useChangePortalAvailabilityRuleMutation,
	useChangePortalCheckoutMethodMutation,
	useChangePortalHelpContactMutation,
	useChangeProductionCatalogStatusMutation,
	useChangeTaskAssignmentDueDateMutation,
	useChangeWorkOrderQuantityProducedMutation,
	useChangeWorkOrderStatusMutation,
	useClaimDeviceMutation,
	useCommitSpaceRebalanceMutation,
	useCompleteAssignmentTaskMutation,
	useCompleteM365MailboxConnectMutation,
	useCompleteMergeLinkMutation,
	useConnectOrderEaseIntegrationMutation,
	useDisconnectM365MailboxMutation,
	useGetM365MailboxAdminConsentUrlQuery,
	useDisconnectOrderEaseIntegrationMutation,
	useOrderEaseIntegrationQuery,
	useCompleteRampConnectMutation,
	useDisconnectRampMutation,
	useRampConnectionQuery,
	useSelectRampEntityMutation,
	useSetRampCopyPurchaseOrdersMutation,
	useStartRampConnectMutation,
	useClearProductionJobsProgressMutation,
	useCompleteTaskMutation,
	useAdjustCountedQuantityMutation,
	useCancelCountSessionMutation,
	useCompleteCountSessionMutation,
	useCorrectCountedTotalMutation,
	usePauseCountSessionMutation,
	useRegisterCountMutation,
	useResumeCountSessionMutation,
	useSetCountedQuantityMutation,
	useSetCountSessionTargetMutation,
	useGetCountProductionLinesQuery,
	useLazyGetCountProductionLinesQuery,
	useGetCountSessionJobNamesQuery,
	useGetCountSessionJobProducedQuery,
	useGetCountSessionJobsQuery,
	useGetCountSessionsByIdsQuery,
	useGetCountSessionsQuery,
	useLazyGetCountSessionsQuery,
	useCountMaterialItemMutation,
	useCreateCountAssignmentMutation,
	useReassignCountAssignmentMutation,
	useUnassignCountAssignmentMutation,
	useGetLocationsByIdsQuery,
	useMyAssignedCountTasksQuery,
	useSetNotificationDocumentReportMutation,
	useSetNotificationRecipientsMutation,
	useSetNotificationSendChoiceMutation,
	useSetNotificationTextRecipientsMutation,
	useSkipAssignmentTaskMutation,
	useStartAssignmentTaskMutation,
	useCreateBlockingRuleMutation,
	useCreateErpLoadListSessionMutation,
	useCreateInvoiceEmailDraftMutation,
	useSendInvoiceEmailMutation,
	useSendMasterOrderEmailMutation,
	useCreateLaborTaskAssignmentMutation,
	useCreateMakeToOrderPlanMutation,
	useCreateMakeToOrderPlanForLinesMutation,
	useLazyGetMakeToOrderPlanPreviewQuery,
	useGetSplitProductionLotQuery,
	useCreateMaterialItemMutation,
	useCreateOrUpdateTagByTagCodeMutation,
	useCreateTagMutation,
	useCombineProductionCatalogsMutation,
	useCombineProductionItemsMutation,
	useCreateProductionCatalogMutation,
	useCreateProductionItemMutation,
	useCreateProductionLotAsyncImportJobMutation,
	useCreateProductionLotMutation,
	useCreateProductionMaterialEventMutation,
	useCreateProductionRecipeMutation,
	useCreateProductionRecipeWithVariationMutation,
	useCreateProductionSpaceEventMutation,
	useCreateProductionTaskEventMutation,
	useCreateProductionTriggerMutation,
	useCreatePromotionRuleMutation,
	useCreateReportFolderMutation,
	useCreateReportMutation,
	useCreateReportScheduleMutation,
	useCreateTaskAssignmentMutation,
	useCreateTaskEventTypeMutation,
	useCreateVendorMutation,
	useCreateVolumePoolMutation,
	useReactivateVolumePoolMutation,
	useCreateUserInviteMutation,
	useResendUserInviteMutation,
	useDeleteUserInviteMutation,
	useCompleteUserInviteAsSignedInUserMutation,
	useCreateUserMutation,
	useCreatePortalUserMutation,
	useAssignUserCustomerMutation,
	useAssignUserCustomersMutation,
	useAssignUserSitesMutation,
	useAssignUserRoutesMutation,
	useCreateBillingPortalSessionMutation,
	useCreateMySubscriptionCheckoutSessionMutation,
	useCreateCommissionConfigMutation,
	useSetCommissionDefaultRateMutation,
	useSetCustomerCommissionOverrideMutation,
	useSetCustomerDepositRequirementMutation,
	useSetCustomerDisabledVolumePoolsMutation,
	useSetCustomerMinimumFreightChargeMutation,
	useSetCustomerOrderEntryUnitMutation,
	useSetCustomerPriceEntryUnitMutation,
	useSetCustomerStatementDeliveryMutation,
	useSetCustomerTaxDetailsMutation,
	useSetCustomerTypeMutation,
	useClearCustomerCommissionOverrideMutation,
	useSetCustomerNoteMutation,
	useClearCustomerNoteMutation,
	useSetCustomerLocationNoteMutation,
	useClearCustomerLocationNoteMutation,
	useAddCustomerLocationSettingsNoteMutation,
	useEditCustomerLocationSettingsNoteMutation,
	useSetCustomerLocationServicingSiteMutation,
	useSetCustomerLocationDeliveryScheduleMutation,
	useSetCustomerLocationCoordinatesMutation,
	useSetCustomerLocationReceivingEmailMutation,
	useSetLocationOrderEmailContactsMutation,
	useGetLoadStopNoticeStatusQuery,
	useGetFreightLoadNumbersQuery,
	usePreviewLoadFreightQuery,
	useApplyLoadFreightMutation,
	useGetFreightQuoteSendStatusQuery,
	useRequestFreightQuoteSendMutation,
	useRequestPlannedArrivalNoticesMutation,
	useResolveUncertainLoadEmailMutation,
	useGetCommissionConfigsQuery,
	useGetMyCommissionConfigQuery,
	useGetUsersForCommissionsQuery,
	useCreateWsapiImportMutation,
	useCustomerLocationsQuery,
	useGetDeviceByIdQuery,
	useGetDeviceFleetQuery,
	useGetDeviceFleetTelemetryLatestQuery,
	useGetDeviceLobbyQuery,
	useGetDeviceDetailQuery,
	useGetDeviceNetworkReportQuery,
	useGetDeviceProfileConfigKeysQuery,
	useGetDeviceTelemetryHistoryQuery,
	useGetDeviceTelemetryLatestForDeviceQuery,
	useGetDeviceWifiChangeStatusQuery,
	useAbortOtaRolloutMutation,
	useCreateOtaReleaseMutation,
	useGetOtaFirmwareReleasesQuery,
	useHaltOtaReleaseMutation,
	usePauseOtaRolloutMutation,
	usePromoteOtaRolloutRingMutation,
	usePublishOtaReleaseMutation,
	useResumeOtaRolloutMutation,
	useStartOtaRolloutMutation,
	useSendDeviceCommandMutation,
	useSetDeviceDesiredConfigMutation,
	useRevokeDeviceCredentialMutation,
	useCustomerPortalCreatePortalUserMutation,
	useCustomerPortalDeactivatePortalUserMutation,
	useCustomerPortalSaveRetailPricesMutation,
	useCustomerPortalUpdatePortalUserMutation,
	useClearItemContainerConfigOverrideMutation,
	useAssignItemGlAccountsMutation,
	useSetItemBatchTrackingMutation,
	useSetItemNoteMutation,
	useSetItemPriceLabelMutation,
	useSetItemShippingUomsMutation,
	useClearItemNoteMutation,
	useUploadItemImageMutation,
	useDeactivateContainerConfigMutation,
	useDeactivateCustomerItemMutation,
	useDeactivateFlatChargeTypeMutation,
	useDeactivateProductionCategoryMutation,
	useDeactivateProductionLotMutation,
	useDeactivateProductionSpaceCategoryMutation,
	useDeactivateProductionSpaceTypeMutation,
	useDeactivateTermsMutation,
	useDeactivateUserMutation,
	useDeleteBlockingRuleMutation,
	useDeleteCustomerMutation,
	useDeleteDeliveryScheduleMutation,
	useDeleteErpLoadListSessionMutation,
	useDeleteItemMutation,
	useDeleteMasterOrderMutation,
	useDeleteMaterialItemMutation,
	useDeleteOrderMutation,
	useDeleteGrowPointIterationsMutation,
	useDeletePriceGroupMutation,
	useDeletePriceLevelMutation,
	useDeletePriceLevelsMutation,
	useActivatePriceGroupMutation,
	useInactivatePriceGroupMutation,
	useDeleteProductionLotMutation,
	useDeleteProductionMaterialEventMutation,
	useDeleteProductionRecipeMutation,
	useDuplicateProductionRecipeMutation,
	useDeleteProductionSpaceCategoryMutation,
	useDeleteProductionSpaceEventMutation,
	useDeleteProductionSpaceTypeMutation,
	useDeleteProductionTaskEventMutation,
	useDeleteProductionTriggerMutation,
	useDismissDuplicateCandidatesMutation,
	useGetDuplicateCandidatesQuery,
	useRunDuplicateCheckMutation,
	useDeletePromotionRuleMutation,
	useDeleteReportFolderMutation,
	useDeleteReportMutation,
	useDeleteReportScheduleMutation,
	useDeleteTaskEventTypeMutation,
	useDeleteTenantIntegrationMutation,
	useDeleteTermsMutation,
	useDeleteUserMutation,
	useDiscardFloatingTimeEntryMutation,
	useDisableWsapiImportMutation,
	useEditCustomerMutation,
	useEditMasterOrderMutation,
	useEditOrderFlatChargeMutation,
	useEditOrderMutation,
	useEnableWsapiImportMutation,
	useFinalizeImportUploadMutation,
	useGetAccountingIntegrationConfigQuery,
	useGetFlatChargeTypesQuery,
	useGetAllocationTemplatesQuery,
	useGetAllContainerConfigsQuery,
	useGetAllDeliverySchedulesQuery,
	useLazyGetAvailabilityPhotoGradeSuggestionQuery,
	useGetBlockingRuleQuery,
	useGetCategoriesQuery,
	useGetCategoryUsedByQuery,
	useLazyGetCategoryUsedByQuery,
	useGetCustomerTypeUsedByQuery,
	useLazyGetCustomerTypeUsedByQuery,
	useGetCategoriesWithShippingUomQuery,
	useGetCombinedOrdersQuery,
	useGetRecentCombinedOrdersQuery,
	useGetCountReasonsQuery,
	useLazyGetCountReasonsQuery,
	useGetMaterialItemLocationQuantitiesQuery,
	useGetCrmSyncIterationsQuery,
	useGetCustomerInvoiceRecipientsQuery,
	useGetCustomerOrderStatsQuery,
	useGetCustomerRetailPricesQuery,
	useLazyGetCustomerRetailPricesQuery,
	useGetCustomerReceivablesQuery,
	useGetReceivablesAgingTotalsQuery,
	useGetCustomerAvgDaysToPayQuery,
	useGetCustomerSalesPaymentsCreditsQuery,
	useGetCustomerMinimumFreightQuery,
	useGetCustomerQuery,
	useGetCustomerTextConsentWordingQuery,
	useGetCustomerTextConsentsQuery,
	useGetCustomerTextingQuery,
	useGetCustomersQuery,
	useGetCustomersTermsByIdsQuery,
	useGetCustomerTopSkusQuery,
	useGetDeliveryScheduleQuery,
	useGetDeliverySchedulesForLookupQuery,
	useGetEffectiveDeliveryScheduleQuery,
	useGetErpFinishAvailabilityQuery,
	useGetErpLoadListAvailabilityQuery,
	useGetErpLoadListQuantitiesQuery,
	useGetErpLoadListSessionQuery,
	useGetErpLoadListSessionsQuery,
	useGetErpLoadListUsersQuery,
	useGetErpStationRoutesQuery,
	useGetErpStationsQuery,
	useGetLoadListItemIdsQuery,
	useGetAllFeatureFlagsQuery,
	useGetIntegrationHealthQuery,
	useGetRevenueRoutingCoverageQuery,
	useGetInventoryAdjustmentAttemptQuery,
	useGetInventoryItemsQuery,
	useGetInventoryTransactionsForKeyQuery,
	useGetInventoryTransactionsQuery,
	useGetCreditMemoNumbersQuery,
	useGetCreditMemoQuery,
	useGetCustomerNamesForInvoicesQuery,
	useGetInvoiceHistoryQuery,
	useGetInvoiceNumbersForHistoryQuery,
	useGetInvoiceQuery,
	useEnsureInvoicePayLinkMutation,
	useGetOnlineInvoicePaymentsEnabledQuery,
	useGetPortalInvoicePaymentAttemptQuery,
	useGetPortalInvoicePaymentQuoteQuery,
	useGetPortalInvoiceQuery,
	usePortalStartInvoiceCheckoutMutation,
	useResendInvoiceEmailMutation,
	useGetItemAvailabilityQuery,
	useGetItemCategoriesQuery,
	useGetItemCombinePreviewQuery,
	useGetItemGlAccountCoverageQuery,
	useGetItemGroupsQuery,
	// useGetItemProgramsQuery, // TODO: restore after programs migration
	useGetItemQuery,
	useGetItemsForSelectorQuery,
	useGetItemsQuery,
	useGetItemSubcategoriesQuery,
	useGetJobCostSubcategoriesQuery,
	useGetJobCostSummaryQuery,
	useGetLotCostSummaryQuery,
	useGetJobCostBreakdownQuery,
	useGetLotCostBreakdownQuery,
	useGetJobCostRecordsQuery,
	useGetLotCostRecordsQuery,
	useGetJobCostTimelineQuery,
	useGetLotCostTimelineQuery,
	useRecordManualJobCostMutation,
	useReverseManualJobCostMutation,
	useGetLaborActiveRatesQuery,
	useGetLaborRateCountQuery,
	useGetLaborDemandQuery,
	useGetLocationOverheadRateQuery,
	useGetLocationOverheadRatesQuery,
	useGetLocationOverheadRateCountQuery,
	useGetLocationSalesPeopleQuery,
	useGetMaterialItemQuery,
	useGetMaterialItemSiteLocationQuantitiesQuery,
	useGetMaterialItemsQuery,
	useGetProduceTagsQuery,
	useGetSellableHardgoodsQuery,
	useGetEarlierCreditsQuery,
	useGetGoLiveChecklistQuery,
	useGetMyQuoteFollowUpsDueQuery,
	useGetOrderQuoteDetailsQuery,
	useGetOrderContainerRequirementQuery,
	useGetOrderDeliveryBillingLinesQuery,
	useGetOrderDeliveryStatusQuery,
	useGetOrderDepositStatusQuery,
	useGetOrderDetailsPdfQuery,
	useGetOrderLocationsQuery,
	useGetOrderNumbersForHistoryQuery,
	useGetOrderProductionLotAllocationsQuery,
	useGetOrderLinesForLotItemQuery,
	useGetOpenOrdersForLotItemQuery,
	useGetOrderMinimumOverridesQuery,
	useGetOrderPaymentsQuery,
	useGetOrderInspectionQuery,
	useGetOrderLineCurrenciesQuery,
	useGetOrderPriceEntryUnitQuery,
	useGetOrderQuery,
	useGetOrderVerificationComparisonQuery,
	useGetOrderVerificationQuery,
	useGetOrdersQuery,
	useGetCustomerPortalEligibleDeliveryDatesQuery,
	useGetCustomerPortalRetailPriceHistoryQuery,
	useGetCustomerPortalSettingsQuery,
	useCustomerPortalAvailabilityPdfQuery,
	useGetPortalAccountQuery,
	useGetPortalCartLineShippingUomsQuery,
	useGetPortalCartQuery,
	useGetPortalCartFreightQuery,
	useGetPortalCustomerOrderLinesQuery,
	useLazyGetLaborRateCountQuery,
	useLazyGetLocationOverheadRateCountQuery,
	useLazyGetLocationOverheadRatesQuery,
	useLazyGetPortalCustomerOrderLinesQuery,
	useGetPortalCustomerOrdersQuery,
	useLazyGetPortalCustomerOrdersQuery,
	useGetCustomerPortalSellableHardgoodsQuery,
	useGetPortalFavoritesListQuery,
	useGetPortalFavoritesListsQuery,
	useGetPortalItemAvailabilityQuery,
	useGetPortalItemPriceQuery,
	useGetPortalItemPricesQuery,
	useGetPortalItemsQuery,
	useGetPortalItemsByIdsQuery,
	useGetPortalPriceGroupQuery,
	useGetPortalPriceLevelsQuery,
	useGetPortalSettingsQuery,
	useGetPostJobsDetailQuery,
	useLazyGetPostJobsDetailQuery,
	useGetPostJobsConsumptionManifestQuery,
	usePostCycleCountsMutation,
	useUpsertRfidScansMutation,
	usePostProductionJobsMutation,
	useConsumeProductionJobsMaterialsMutation,
	useLazyGetProductionJobPostingStagesQuery,
	useRepairProductionJobReservationPegsMutation,
	useReopenProductionJobMutation,
	useResolveProduceTagsQuery,
	useGetResolvedSkuUpcMappingsQuery,
	useAdjustPostedProductionMutation,
	useGetProductionJobAdjustmentDetailQuery,
	useLazyGetProductionJobAdjustmentDetailQuery,
	useGetPriceGroupQuery,
	useGetPriceGroupMetaQuery,
	useLazyGetPriceGroupMetaQuery,
	useGetPriceGroupsQuery,
	useGetPriceGroupUsedByQuery,
	useLazyGetPriceGroupUsedByQuery,
	useGetProductionCatalogQuery,
	useGetProductionCatalogCombinePreviewQuery,
	useGetProductionCatalogsQuery,
	useGetEffectiveSpaceCategoryDimensionsQuery,
	useGetProductionCategoriesQuery,
	useGetProductionCategoryQuery,
	useGetProductionItemCombinePreviewQuery,
	useGetProductionItemNumberMatchesQuery,
	useGetProductionItemsQuery,
	useGetItemProductionMappingsQuery,
	useGetProductionItemsCatalogQuery,
	useLazyGetItemProductionMappingsQuery,
	useSetItemProductionMappingsMutation,
	useGetProductionItemOrderLinesByShipWeekQuery,
	useGetProductionJobDimensionsQuery,
	useGetProductionJobGrowWeeksQuery,
	useGetProductionJobLabelsQuery,
	useGetProductionJobPurchaseOrdersQuery,
	useGetProductionJobsForEventsQuery,
	useLazyGetProductionJobsForEventsQuery,
	useGetProductionJobsQuery,
	useGetProductionLotQuery,
	useLazyGetProductionLotQuery,
	useLazyGetSplitProductionLotQuery,
	useGetProductionLotOverrideHistoryQuery,
	useGetProductionLotTimelineQuery,
	useGetShrinkLossLotsQuery,
	useGetShrinkLossReportQuery,
	useGetProductionLotsQuery,
	useGetProductionLotEachesQuery,
	useGetProductionScheduleJobQuery,
	useLazyGetProductionScheduleJobQuery,
	useGetProductionScheduleLotJobsQuery,
	useLazyProductionJobMovePreviewQuery,
	useLazyOpenPlannedMovesQuery,
	usePlanProductionJobMovesMutation,
	useProductionLotSubstitutionPreviewQuery,
	useLazyProductionLotSubstitutionPreviewQuery,
	useLazyGetProductionLotVariantOptionsQuery,
	useGetProductionMaterialEventDetailsQuery,
	useLazyGetProductionMaterialEventDetailsQuery,
	useGetProductionMaterialEventQuery,
	useLazyGetProductionMaterialEventQuery,
	useGetProductionMaterialEventsQuery,
	useGetProductionPlansQuery,
	useGetProductionRecipeBomQuery,
	useGetProductionRecipeChainQuery,
	useGetProductionRecipeHistoryQuery,
	useGetProductionRecipeMaterialVendorOverridesQuery,
	useGetProductionRecipeQuery,
	useGetProductionRecipesQuery,
	useGetProductionRecipesLinkingPairQuery,
	useGetProductionRecipeVariationEffectiveYieldQuery,
	useGetProductionRecipeVariationsQuery,
	useGetRecipeVariationTagsQuery,
	useGetProductionSpaceCategoriesQuery,
	useGetProductionSpaceCategoryQuery,
	useGetProductionSpaceEventDetailsQuery,
	useGetProductionSpaceEventQuery,
	useLazyGetProductionSpaceEventQuery,
	useGetProductionSpaceEventsQuery,
	useGetProductionSpaceTypeQuery,
	useGetProductionSpaceTypesQuery,
	useGetProductionTaskEventDetailsQuery,
	useGetProductionTaskEventQuery,
	useLazyGetProductionTaskEventQuery,
	useGetProductionTaskEventsQuery,
	useGetTaskEventCostsQuery,
	useGetProductionTriggersQuery,
	useGetMyActiveReapplyRecipesRunsQuery,
	useGetReapplyRecipesPreviewQuery,
	useLazyGetReapplyRecipesPreviewQuery,
	useGetReapplyRecipesRunQuery,
	useStartReapplyRecipesRunMutation,
	useReactivateFlatChargeTypeMutation,
	useReactivateUserMutation,
	useResetUserLoginMutation,
	useSetMyLanguagePreferenceMutation,
	useIgnoreMissingDataMutation,
	useUnignoreMissingDataMutation,
	useSetMyNotificationPreferencesMutation,
	useSetMyWhatsNewEmailMutation,
	useRequestMyPhoneVerificationMutation,
	useConfirmMyPhoneVerificationMutation,
	useRegisterMyPushSubscriptionMutation,
	useRemoveMyPushSubscriptionMutation,
	useStartMyMultiFactorEnrollmentMutation,
	useCompleteMyMultiFactorEnrollmentMutation,
	useDisableMyMultiFactorMutation,
	useRegenerateMyMultiFactorRecoveryCodesMutation,
	useSetTenantMultiFactorRequirementMutation,
	useGetInboundDocumentsQuery,
	useGetInboundDocumentQuery,
	useGetInboundDocumentAvailableTargetsQuery,
	useGetInboundIntakeSettingsQuery,
	useSetInboundDocumentKindMutation,
	useRouteInboundDocumentMutation,
	useDiscardInboundDocumentMutation,
	useRotateInboundIntakeAddressMutation,
	useAddInboundAllowedSenderMutation,
	useRemoveInboundAllowedSenderMutation,
	useUpdateInboundDocumentSettingsMutation,
	useSetMyProfileImageMutation,
	useClearMyProfileImageMutation,
	useClearOrderNoteMutation,
	useClearOrderNoTaxMutation,
	usePlaceOrderHoldMutation,
	useRefreshOrderTaxEstimateMutation,
	useReleaseOrderHoldMutation,
	useStoredConsolidationPreviewQuery,
	useLazyConsolidationPreviewLotsQuery,
	useLazyConsolidationApplicationQuery,
	useConsolidationApplicationsQuery,
	useConsolidationApplicationLotsQuery,
	useCreateConsolidationPreviewMutation,
	useSetConsolidationLotPinsMutation,
	useApplyConsolidationPreviewMutation,
	useUndoConsolidationApplicationMutation,
	useGetConsolidationRulesQuery,
	useGetConsolidationRulesVersionsQuery,
	useSaveConsolidationRulesMutation,
	useGetPromotionRuleQuery,
	useGetReplenishmentRulesQuery,
	useGetReplenishmentSettingsQuery,
	useGetRestockDailyDemandSummaryQuery,
	useGetRestockDashboardRowsQuery,
	useGetRestockFullCartPreviewQuery,
	useGetRestockMetricsQuery,
	useGetRestockSessionCalcStatusQuery,
	useGetRestockSessionKitsQuery,
	useGetRestockSessionOrderItemsBlockQuery,
	useGetRestockSessionOrderItemsQuery,
	useGetRestockSessionOrderQuantityOverrideHistoryQuery,
	useGetRestockSessionQuery,
	useGetRestockSessionsQuery,
	useGetRestockSessionSubmitSummaryQuery,
	useLazyGetRestockFullCartPreviewQuery,
	useLazyGetRestockRowExplanationQuery,
	useLazyGetRestockSessionCreationExclusionsQuery,
	useLazyGetRestockSessionOrderItemsBlockQuery,
	useLazyGetRestockSessionOrderItemsQuery,
	useLazyGetRestockSessionOrderQuantityOverrideHistoryQuery,
	useLazyGetRestockSessionQuery,
	useLazyGetRestockSessionRowCalcStepsQuery,
	useLazyGetRestockSessionsQuery,
	useLazyGetRoutesQuery,
	useAttachRestockSessionKitMutation,
	useAutoAllocateRestockSessionOrderQuantitiesMutation,
	useCancelRestockSessionMutation,
	useCancelScheduledInventoryTransferMutation,
	useCreateRestockSessionMutation,
	useDeleteRestockSessionMutation,
	useOverrideOrderLineUpgradePricingMutation,
	useOverrideRestockSessionOrderQuantitiesMutation,
	useRequestRestockCalculationMutation,
	useRoundRestockSessionOrderQuantityToFullCartMutation,
	useSetRestockSessionOrderQuantitiesMutation,
	useStartRestockSessionCreationMutation,
	useSubmitDraftProductionLotMutation,
	useSubmitRestockSessionMutation,
	useSynchronizeRestockSessionMutation,
	useUpdateRestockSessionMutation,
	useUpdateRestockSessionReserveRulesMutation,
	useGetEmailSendsQuery,
	useGetEmailSendDetailQuery,
	useClearEmailSuppressionMutation,
	useGetOrderEmailSchedulesQuery,
	useGetOrderTextHistoryQuery,
	useGetOrderEmailSettingsQuery,
	useGetOrderEmailNotificationCatalogQuery,
	useSetInvoiceEmailChannelMutation,
	useSetOrderEmailSettingsMutation,
	useSetOrderEmailEnablementMutation,
	useGetOrderEmailRecipientRoutingQuery,
	useSetOrderEmailRecipientRoutingMutation,
	useClearOrderEmailRecipientRoutingMutation,
	useSetOrderNoteMutation,
	useSetOrderNoTaxMutation,
	useSetOrderQuoteDetailsMutation,
	useSetOrderShipFromSiteMutation,
	useSetOrderContainerMutation,
	useSetOrderKindMutation,
	useSetOrderPlannedShipDateMutation,
	useSetOrderProgramMutation,
	useScheduleMasterOrderWeekMutation,
	useSetOrderDropShipDestinationMutation,
	useClearOrderDropShipDestinationMutation,
	useSetReportAppTagsMutation,
	useSetReportScheduleEmailSettingsMutation,
	useGetTenantEmailSendersQuery,
	useGetSelectableEmailSendersQuery,
	useGetEffectiveEmailSenderQuery,
	useGetTenantEmailSenderSelectionQuery,
	useGetSenderDomainPolicyQuery,
	useAddTenantEmailSenderMutation,
	useRequestTenantEmailSenderVerificationMutation,
	useRefreshTenantEmailSenderStatusMutation,
	useSetEmailSenderAdminOnlyMutation,
	useSetTenantDefaultEmailSenderMutation,
	useSetTenantDefaultRouteMutation,
	useScheduleInventoryTransferMutation,
	useSetRouteDeliveryScheduleMutation,
	useUnsetRouteDeliveryScheduleMutation,
	useSetTenantDefaultCarrierMutation,
	useSetTenantAvailabilityQuantityBasisMutation,
	useSetTenantAvailabilityQuantityEntryMutation,
	useSetTenantOrderEntryUnitMutation,
	useSetTenantPriceEntryUnitMutation,
	useUpdatePricingCalcDecimalsMutation,
	useUpdateBusinessTimeZoneMutation,
	useSetTenantLoadPaperworkBindingMutation,
	useSetTenantLoadPaperworkPolicyMutation,
	useUpdateProduceAutoLinkMatchingNumbersMutation,
	useUpdateProduceRoundingMutation,
	useUpdateProducePlanningEntryUnitMutation,
	useUpdateProduceWeekDisplayAnchorMutation,
	useUpdateProduceSpacingDimensionUnitMutation,
	useUpdateProduceSpaceConsumptionBasisMutation,
	useUpdateProduceDefaultReliefPercentMutation,
	useUpdateProducePlanFromOrderAccessMutation,
	useUpdateProduceProductionEntryReviewMutation,
	useSubmitProducedQuantityForReviewMutation,
	useConfirmProducedQuantityEntryMutation,
	useRejectProducedQuantityEntryMutation,
	useGetPendingProductionEntriesQuery,
	useRemoveTenantEmailSenderMutation,
	useCompleteTenantEmailSenderVerificationMutation,
	useGetTenantEmailDomainQuery,
	useAddTenantEmailDomainMutation,
	useValidateTenantEmailDomainMutation,
	useRemoveTenantEmailDomainMutation,
	useGetTenantSmtpConnectionQuery,
	useSetTenantSmtpConnectionMutation,
	useVerifyTenantSmtpConnectionMutation,
	useRemoveTenantSmtpConnectionMutation,
	useGetReportByIdQuery,
	useGetReportCurrentVersionQuery,
	useGetReportDataSourcesQuery,
	useGetReportExecutionByIdQuery,
	useGetReportExecutionsQuery,
	useGetReportFoldersQuery,
	useGetReportSchedulesQuery,
	useGetReportsQuery,
	useGetReportTemplatesQuery,
	useGetReportVersionsQuery,
	useReportsByAppTagQuery,
	useGenerateReportCsvQuery,
	useGenerateReportExcelQuery,
	useGenerateReportPdfQuery,
	useGetSiteLocationQuery,
	useGetSiteLocationsQuery,
	useGetSiteLocationTypeRelationshipsQuery,
	useGetStoreClassesQuery,
	useGetSynchronizationIterationsQuery,
	useCancelBackgroundJobMutation,
	useClearFinishedBackgroundJobsMutation,
	useDismissBackgroundJobMutation,
	useGetBackgroundJobItemsQuery,
	useGetBackgroundJobQuery,
	useGetMyBackgroundJobsQuery,
	useLazyGetBackgroundJobItemsQuery,
	useRequestBackgroundJobMutation,
	useRetryFailedBackgroundJobItemsMutation,
	useGetMyNotificationsQuery,
	useGetMyTaskAssignmentsQuery,
	useGetMyUnreadNotificationCountQuery,
	useGetSubLocationCombinePreviewQuery,
	useGetSubLocationQuery,
	useGetSubLocationsBasicQuery,
	useLazyGetSubLocationsBasicQuery,
	useGetSubLocationsQuery,
	useGetSpaceCapacityWindowsQuery,
	useLazyGetSpaceCapacityWindowsQuery,
	useSetSpaceCapacityWindowMutation,
	useReplaceSpaceCapacityWindowMutation,
	useRemoveSpaceCapacityWindowMutation,
	useGetSpaceTypeCapacitiesQuery,
	useSetSpaceTypeCapacityMutation,
	useRemoveSpaceTypeCapacityMutation,
	useGetProductionYearPlanQuery,
	useGetProductionYearPlanYearsQuery,
	useSetProductionYearPlanCellsMutation,
	useSetProductionYearPlanProductionPlanMutation,
	useSetProductionYearPlanItemMutation,
	useGetTaskAssignmentQuery,
	useGetTaskPlannedMoveQuery,
	useLazyGetTaskAssignmentQuery,
	useGetTaskAssignmentsQuery,
	useGetTaskEventTypesQuery,
	useGetTenantIntegrationDocumentsQuery,
	useGetTenantBillingQuery,
	useGetTenantBillsThroughErpQuery,
	useGetTenantQuery,
	useGetMyOnboardingPlanQuery,
	useGetOnboardingJourneyFilesQuery,
	useGetOnboardingWelcomeQuery,
	useGetMigrationImportQuestionsQuery,
	useGetMigrationPreparedRowsQuery,
	useGetMigrationReviewQuery,
	useRegisterOnboardingUploadMutation,
	useStartOrResumeOnboardingJourneyMutation,
	useSnoozeOnboardingWelcomeMutation,
	useDismissOnboardingWelcomeMutation,
	useMyLearningPathQuery,
	useLazyMyLearningPathQuery,
	useMyWalkthroughStateQuery,
	useRecordLearningConceptExplainedMutation,
	useRecordLearningWalkthroughOutcomeMutation,
	useGetTenantStripeConnectQuery,
	useCreateTenantStripeConnectedAccountMutation,
	useCreateTenantStripeAccountSessionMutation,
	useRefreshTenantStripeTaxReadinessMutation,
	useGetTenantRouteConfigQuery,
	useGetRouteDeliveryScheduleConfigQuery,
	useGetScheduledInventoryTransfersQuery,
	useGetTenantCarrierConfigQuery,
	useGetTenantUomNamesQuery,
	useAddTenantUomNameMutation,
	useGetTermsByIdQuery,
	useGetTermsByNamesQuery,
	useGetTermsQuery,
	useGetTermsCombinePreviewQuery,
	useCombineTermsMutation,
	useRevertTermsCombineMutation,
	useGetUnallocatedAvailabilityQuery,
	useGetMeQuery,
	useGetMissingDataFindingsQuery,
	useLazyGetMissingDataFindingsQuery,
	useGetMyIgnoredMissingDataQuery,
	useGetMyNotificationPreferencesQuery,
	useGetMyLanguagePreferenceQuery,
	useLazyGetPortalBuyersForCustomerDeleteQuery,
	useGetUserInvitesQuery,
	useGetUserAppSettingsQuery,
	useGetMyWhatsNewEmailQuery,
	useGetWhatsNewQuery,
	useRequestEarlyAccessMutation,
	useGetUsersForSalesPersonLookupQuery,
	useGetUsersForUserAdminQuery,
	useLazyGetUsersForUserAdminQuery,
	useGetCustomerNamesForUserAdminQuery,
	useGetVendorPurchaseOrderLineCostPreviewQuery,
	useGetVendorPurchaseOrderQuery,
	useGetVendorPurchaseOrdersQuery,
	useGetRampPurchaseOrderCopyQuery,
	useGetRampPurchaseOrderInvoicesQuery,
	useGetUnlinkedRampBillsForPurchaseOrderQuery,
	useLinkRampBillToPurchaseOrderMutation,
	useRequestRampPurchaseOrderCopyMutation,
	useUnlinkRampBillFromPurchaseOrderMutation,
	useGetVolumePoolsQuery,
	useGetWsapiImportQuery,
	useImportCustomerRetailPricesMutation,
	useImportOrdersMutation,
	useInactivateCategoryMutation,
	useImportUpsertCustomerMutation,
	useInactivateCustomerMutation,
	useInactivateItemMutation,
	useInactivateMaterialItemMutation,
	useInactivateProductionItemMutation,
	useInactivateProductionMaterialEventMutation,
	useInactivateProductionRecipeMutation,
	useInactivateProductionSpaceEventMutation,
	useInactivateProductionTaskEventMutation,
	useInactivateProductionTriggerMutation,
	useInactivateTaskEventTypeMutation,
	useCreditExistingOrderMutation,
	useRecordOrderDepositMutation,
	useInitializeMasterOrderMutation,
	useInitializeOrderMutation,
	useLazyCustomerLocationsQuery,
	useLazyGetAllContainerConfigsQuery,
	useLazyGetAllDeliverySchedulesQuery,
	useLazyGetAllLogisticsRoutesQuery,
	useLazyGetBlockingRuleQuery,
	useLazyGetCategoriesQuery,
	useLazyGetCatalogSubstitutionLotQuery,
	useLazyGetCategoriesWithShippingUomQuery,
	useLazyGetCombinedOrdersQuery,
	useLazyGetConfigCategoriesQuery,
	useLazyGetCustomerIdentitiesByNamesQuery,
	useLazyGetCustomerLocationsWithBaseRateOfSaleQuery,
	useLazyGetCustomerNotificationSettingsQuery,
	useLazyGetCustomerPortalRetailPriceSaveQuery,
	useLazyGetCustomerPortalRetailPriceSaveRowsQuery,
	useLazyGetCustomerQuery,
	useLazyGetCustomerReceivablesQuery,
	useLazyGetCustomerTypeNamesByIdsQuery,
	useLazyGetCustomersByNamesQuery,
	useLazyGetCustomersForImportQuery,
	useLazyGetCustomersQuery,
	useLazyGetErpFinishAvailabilityQuery,
	useLazyGetErpLoadListSessionQuery,
	useLazyGetErpLoadListUsersQuery,
	useLazyGetErpStationRoutesQuery,
	useLazyGetInventoryAdjustmentAttemptQuery,
	useLazyGetInventoryItemsQuery,
	useLazyGetInvoicePaymentPreviewQuery,
	useLazyGetItemPriceQuery,
	useLazyGetItemProgramsQuery,
	useLazyGetDeviceLobbyQuery,
	useLazyGetItemQuery,
	useLazyGetItemsForSelectorQuery,
	useLazyGetItemsQuery,
	useLazyGetItemsWithBaseRateOfSaleQuery,
	useLazyGetKitsQuery,
	useLazyGetLocationInUseQuery,
	useLazyGetLocationOverheadRateQuery,
	useLazyGetLocationSalesPeopleQuery,
	useLazyGetMasterOrderQuery,
	useLazyGetMasterOrdersQuery,
	useLazyGetMaterialItemLocationQuantitiesQuery,
	useLazyGetMaterialItemQuery,
	useLazyGetMaterialItemSiteLocationQuantitiesQuery,
	useLazyGetMaterialItemsQuery,
	useLazyGetProduceTagsByTagCodesQuery,
	useLazyGetOrderContainerRequirementQuery,
	useLazyGetOrderContainerRequirementsQuery,
	useLazyGetOrderDeliveryStatusQuery,
	useLazyGetOrderDetailsPdfQuery,
	useLazyGetOrderInspectionQuery,
	useLazyGetOrderLinePricePreviewQuery,
	useLazyGetOrderProductionLotAllocationsQuery,
	useLazyGetOrderProductionLotAllocationByIdQuery,
	useLazyGetOrderQuery,
	useLazyGetOrderRouteInspectionQuery,
	useLazyGetOrderStatusQuery,
	useLazyGetOrderVerificationComparisonQuery,
	useLazyGetOrdersForKitOrderImportQuery,
	useLazyGetOrdersGridListQuery,
	useLazyGetOrdersQuery,
	useLazyGetRoutableOrdersQuery,
	useLazyGetPortalItemPriceQuery,
	useLazyGetPortalItemPricesQuery,
	useLazyGetPortalItemsQuery,
	useLazyGetPortalPriceGroupQuery,
	useLazyGetPortalPriceLevelsQuery,
	useLazyGetPriceGroupQuery,
	useLazyGetPriceGroupsQuery,
	useLazyGetProductionCatalogsQuery,
	useLazyGetEffectiveSpaceCategoryDimensionsQuery,
	useLazyGetProductionCategoriesQuery,
	useLazyGetProductionItemsQuery,
	useLazyGetProductionItemLinksPreviewQuery,
	useLazyGetProductionJobsQuery,
	useLazyGetProductionMaterialEventDetailsByEventsQuery,
	useLazyGetProductionMaterialEventsQuery,
	useLazyGetProductionRecipeQuery,
	useLazyGetProductionRecipesLinkingPairQuery,
	useLazyGetProductionRecipesQuery,
	useLazyGetProductionSpaceCategoriesQuery,
	useLazyGetProductionSpaceEventDetailsQuery,
	useLazyGetProductionSpaceEventsQuery,
	useLazyGetProductionSpaceTypesQuery,
	useLazyGetProductionTaskEventsQuery,
	useLazyGetProductionTriggersQuery,
	useLazyGetProgramsQuery,
	useLazyGetPromotionRuleQuery,
	useLazyGetReplenishmentRulesQuery,
	useLazyGetSiteLocationQuery,
	useLazyGetSiteLocationsQuery,
	useLazyGetSiteLocationTypeRelationshipsQuery,
	useLazyGetSizeUomsQuery,
	useLazyGetSkuUpcMappingsForItemsQuery,
	useLazyGetStoreClassesQuery,
	useLazyGetSubLocationQuery,
	useLazyGetSubLocationsQuery,
	useLazyGetTaskEventTypesQuery,
	useLazyGetTenantQuery,
	useLazyGetStockByCustomerItemDisablePreviewQuery,
	useLazyGetTermsByIdQuery,
	useLazyGetTermsByNamesQuery,
	useLazyGetTermsMatchingNamesQuery,
	useLazyGetTermsQuery,
	useAddEffectiveMaterialPriceMutation,
	useCorrectMaterialPriceMutation,
	useVoidMaterialPriceMutation,
	useGetMaterialPriceHistoryQuery,
	useGetMaterialPriceWriteCapabilityQuery,
	useApplySupplierPriceImportMutation,
	useCancelSupplierPriceExtractionMutation,
	useCancelSupplierPriceImportApprovalMutation,
	useCreateSupplierPriceImportMutation,
	useDecideSupplierPriceImportRowMutation,
	useDiscardSupplierPriceImportMutation,
	useAgGridRowsQuery,
	useGetSupplierPriceImportApplyQuery,
	useGetSupplierPriceImportHeldRowsQuery,
	useGetSupplierPriceImportQuery,
	useGetSupplierPriceImportRowCandidatesQuery,
	useGetSupplierPriceImportRowsQuery,
	useGetSupplierPriceImportsQuery,
	useAddVendorItemAliasMutation,
	useLazyGetVendorItemAliasesQuery,
	useLazyGetVendorItemResolutionsQuery,
	useRetireVendorItemAliasMutation,
	useReviewSupplierPriceImportRowMutation,
	useSelectSupplierPriceImportRowMutation,
	useLazyGetMaterialPriceActionPreviewQuery,
	useLazyGetVendorMaterialCostsQuery,
	useGetVendorMaterialCostsQuery,
	useLazyGetVendorPurchaseOrderQuery,
	useLazyGetVendorPurchaseOrdersQuery,
	useLazyGetVendorsQuery,
	useGetVendorsQuery,
	useLinkSuggestedRampVendorsMutation,
	useLinkVendorToRampVendorMutation,
	useRampVendorLinkRowsQuery,
	useRampVendorsQuery,
	useUnlinkVendorFromRampVendorMutation,
	useVendorRampLinkQuery,
	useLazyGetVerifyOrderByNumberQuery,
	useGetPullLoadsQuery,
	useGetVerifyOrderVerificationQuery,
	useLazyGetVolumePoolsQuery,
	useLazyGetReportDataSourcesQuery,
	useLazyGetReportByIdQuery,
	useLazyGenerateReportCsvQuery,
	useLazyGenerateReportExcelQuery,
	useLazyGenerateReportPdfQuery,
	useLazyCustomerPortalAvailabilityPdfQuery,
	useLazyGetReportTemplateSummariesQuery,
	useLazyLocationsQuery,
	useLocationQuery,
	useLocationsQuery,
	useMarkAllNotificationsReadMutation,
	useMarkNotificationReadMutation,
	useMarkOrdersForInvoicingMutation,
	useMarkNotificationUnreadMutation,
	useMergeContainerConfigMutation,
	useGetMergeDevSyncStateQuery,
	useGetMergeDevImportFailuresQuery,
	useGetMergeDevExportsQuery,
	useMergeCustomerMutation,
	useMergeDeliveryScheduleMutation,
	useMergeForecastSettingsMutation,
	useMergeItemMutation,
	usePatchItemMutation,
	useRemoveItemMinShipQtyMutation,
	useRemoveItemSubstitutionMutation,
	useMergeLinkTokenMutation,
	useMergePriceLevelMutation,
	useMergeProductionCategoryMutation,
	useMergeProductionPlanMutation,
	useMergeProductionSpaceCategoryMutation,
	useMergeProductionSpaceTypeMutation,
	useClearSpaceDimensionOverrideMutation,
	useSetSpaceDimensionOverrideMutation,
	useMergeReplenishmentSettingsMutation,
	useMergeSiteLocationMutation,
	useAddBayPolesMutation,
	useAddSubLocationMutation,
	useUpdateSubLocationMutation,
	useInactivateSubLocationMutation,
	useRemoveSubLocationMutation,
	useInactivateSiteLocationMutation,
	useCombineSubLocationsMutation,
	useDeleteSiteLocationMutation,
	useMoveMaterialItemMutation,
	useAdjustMaterialItemMutation,
	useAtomicMoveMutation,
	useCreateMovementOrderMutation,
	useShipMovementOrderMutation,
	useReceiveMovementOrderMutation,
	useGetPendingTransferOrdersByDestinationQuery,
	useOverrideProducedQuantityMutation,
	useOverrideProductionJobLocationMutation,
	useUpdateProductionJobLocationMutation,
	useOverrideProductionJobQuantityMutation,
	useOverrideProductionJobWeekReadyMutation,
	useOverrideProductionJobWeekStartMutation,
	useOverrideProductionJobYieldMutation,
	useOverrideProductionLotCustomerMutation,
	useClearProductionLotCustomerMutation,
	useOverrideProductionLotCustomerGroupMutation,
	useClearProductionLotCustomerGroupMutation,
	useSetProductionLotProductionItemMutation,
	useOverrideProductionLotQuantityMutation,
	useSplitProductionLotMutation,
	useSubstituteProductionLotCatalogMutation,
	usePortalAddContactMutation,
	usePortalAddLineItemsMutation,
	usePortalCompleteCheckoutMutation,
	usePortalCreateCartMutation,
	usePortalCreateFavoritesListMutation,
	usePortalDeleteEmptyOrderMutation,
	usePortalDeleteFavoritesListMutation,
	usePortalGetNextOrderNumberMutation,
	usePortalInitializeOrderMutation,
	usePortalPlaceOrderMutation,
	usePortalRemoveContactMutation,
	usePortalSetFavoritesListActiveMutation,
	usePortalUpdateCartMutation,
	usePortalUpdateContactMutation,
	usePortalUpdateFavoritesListMutation,
	useAddPortalCustomDomainMutation,
	useVerifyPortalCustomDomainMutation,
	useSetPrimaryPortalCustomDomainMutation,
	useRemovePortalCustomDomainMutation,
	useProcessErpLoadListSessionMutation,
	useReassignTaskMutation,
	useUnassignTaskMutation,
	useLazyGetProductionLotOpenAllocationsQuery,
	useReassignWsapiImportIntegrationMutation,
	useReceiveVendorPurchaseOrderItemsMutation,
	useRecordContactTextConsentMutation,
	useRecordImportSessionMutation,
	useRecordInvoicePaymentMutation,
	useRetryInvoiceExportMutation,
	useRetryPaymentExportMutation,
	useRecordOrderPullsMutation,
	useRecordShrinkEventMutation,
	useRecordUserActivityMutation,
	useReconnectMergeLinkMutation,
	useRemoveBlockingRuleLinkedItemsMutation,
	useRemoveBlockingRuleLinkedLocationsMutation,
	useRemovePromotionRuleLinkedItemsMutation,
	useRemovePromotionRuleLinkedLocationsMutation,
	useRemoveBillingAddressMutation,
	useRemoveCategoryMutation,
	useRemoveContactMutation,
	useRemoveImportRowsMutation,
	useRemoveItemAvailabilityPhotoMutation,
	useRemoveLineItemAllocationsMutation,
	useRemoveLineItemMutation,
	useRemoveMasterLineItemMutation,
	useRemoveLocationMutation,
	useRemoveOrderFlatChargeMutation,
	useRemoveOrderLineUpgradeMutation,
	useRemoveProductionMaterialEventDetailMutation,
	useRemoveProductionMaterialEventFromCategoryMutation,
	useRemoveProductionMaterialEventFromJobMutation,
	useRemoveProductionRecipeVariationMutation,
	useRemoveProductionSpaceEventDetailMutation,
	useRemoveProductionSpaceEventFromCategoryMutation,
	useRemoveProductionSpaceEventFromJobMutation,
	useRemoveProductionTaskEventDetailMutation,
	useRemoveProductionTaskEventFromCategoryMutation,
	useRemoveShrinkEventMutation,
	useRemoveVerifyContainerMutation,
	useRemoveWsapiImportEntityMappingMutation,
	useRenameCategoryMutation,
	useRenameDeviceMutation,
	useRenameReportFolderMutation,
	useReplaceCustomerSalesPeopleMutation,
	useRepointProductionRecipeLinksMutation,
	useRepriceOrderLineMutation,
	useRepriceOrderMutation,
	useResetOrderSyncStatusMutation,
	useRevalidateImportMutation,
	useRevertReportMutation,
	useRunReportMutation,
	useRevertProductionCatalogCombineMutation,
	useRevertProductionItemCombineMutation,
	useRevertSubLocationCombineMutation,
	useReplaceLocationSalesPeopleMutation,
	useSetAccountingIntegrationConfigMutation,
	useSetAccountingLineAccountsMutation,
	useSetCategoryIncomeGlAccountMutation,
	useSetCategoryLaborCostMutation,
	useSetCategoryUnitsPerPoleMutation,
	useSetDefaultGroupMutation,
	useSetDefaultTermsMutation,
	useSetPriceGroupDerivationMutation,
	useSetPriceGroupOrderVolumeDiscountMutation,
	useSetPriceGroupQualificationConditionsMutation,
	useSetPriceLevelsVolumePoolMutation,
	useAdjustPriceLevelsMutation,
	useSetDefaultVendorMutation,
	useSetMaterialItemBatchTrackingMutation,
	useSetMaterialItemBaseUnitMutation,
	useLazyMaterialUnitRelabelImpactQuery,
	useSetMaterialItemImageMutation,
	useSetMaterialItemTagSpecMutation,
	useLinkFloatingTimeEntryMutation,
	useLinkFusionAuthUserMutation,
	useLinkFusionAuthUserByEmailMutation,
	useLinkProductionItemsToSalesItemMutation,
	useLinkProductionItemsToSalesItemsMutation,
	useUnlinkFusionAuthUserMutation,
	useAddItemUpgradeMutation,
	useUpdateItemUpgradeMutation,
	useToggleItemUpgradeDefaultMutation,
	useDeactivateItemUpgradeMutation,
	useSetItemAvailabilityPhotoPrimaryMutation,
	useSetItemContainerConfigOverrideMutation,
	useSetItemLaborCostMutation,
	useClearItemLaborCostMutation,
	useSetJobPlannedHoursOverrideMutation,
	useClearJobPlannedHoursOverrideMutation,
	useSetJobPlantsPerPotOverrideMutation,
	useSetLaborTypesMutation,
	useSetLineItemCustomerItemMutation,
	useSetLineItemOverridePriceMutation,
	useSetLineItemShippingUomMutation,
	useSetLocationDefaultSpaceTypeMutation,
	useSetLocationOverheadRateMutation,
	useSetProductionRecipeAdditionalCostEventIdsMutation,
	useSetProductionRecipeFlatRateCostMutation,
	useSetProductionRecipeMaterialVendorMutation,
	useSetProductionRecipeTaskEventIdsMutation,
	useSetProductionRecipeTypeMutation,
	useSetRecipeLaborSourceMutation,
	useSetSiteLaborRateMutation,
	useSetSiteContactsMutation,
	useSetSiteLocationCoordinatesMutation,
	useSetSiteTimeZoneMutation,
	useSetStoreClassesMutation,
	useClearTaskEventDirectCostMutation,
	useClearTaskEventLaborTypeTagMutation,
	useClearTaskEventThroughputMutation,
	useSetTaskEventDetailThroughputMutation,
	useSetTaskEventDirectCostMutation,
	useSetTaskEventLaborTypeTagMutation,
	useSetTaskEventThroughputMutation,
	useSetVendorMaterialCostMutation,
	useSetWsapiImportRunNowMutation,
	useSpaceUtilizationAllSitesQuery,
	useSpaceUtilizationDrilldownQuery,
	useSpaceUtilizationPreviewQuery,
	useSpaceUtilizationQuery,
	useGetResolvedSpaceCapacityQuery,
	useStartFloatingTimerMutation,
	useStartTaskMutation,
	useStopContactTextsMutation,
	useStopFloatingTimerMutation,
	useSubmitErpLoadListSessionMutation,
	useSubmitOrderVerificationMutation,
	useSubmitVerifyContainerMutation,
	useUnassignMaterialItemToVendorMutation,
	useUndeleteMaterialItemMutation,
	useUndoRestockSessionOrderQuantityOverrideMutation,
	useUnlinkProductionItemGridRowsMutation,
	useUnlinkProductionItemsFromSalesItemMutation,
	useUnsetDefaultTermsMutation,
	useUnshipOrderMutation,
	useUpdateAcknowledgedQuantityMutation,
	useUpdateAndGetNextOrderNumberMutation,
	useUpdateAsyncImportJobStatusMutation,
	useUpdateBillingAddressMutation,
	useUpdateBlockingRuleMutation,
	useUpdateCategoryMutation,
	useUpdateFlatChargeTypeMutation,
	useUpdateContactMutation,
	useUpdateCustomerItemMutation,
	useUpdateCustomerLocationSendInvoiceEmailsMutation,
	useUpdateCustomerLocationSendOrderEmailsMutation,
	useUpdateCustomerSendInvoiceEmailsMutation,
	useUpdateCustomerSendOrderEmailsMutation,
	useUpdateDefaultMinimumFreightChargeMutation,
	useUpdateDefaultFreightChargeMutation,
	useUpdateProduceEnabledMutation,
	useUpdateTrackShipmentWeightMutation,
	useUpdateOrderInvoiceReportMutation,
	useUpdateOrderAcknowledgementReportMutation,
	useUpdateOrderProFormaReportMutation,
	useUpdatePurchaseOrderReportMutation,
	useUpdateOrderPullSlipReportMutation,
	useUpdateDocumentRenderModeMutation,
	useUpdateInvoicingSettingsMutation,
	useUpdateStockByCustomerItemSettingsMutation,
	useUpdateStatementDeliverySettingsMutation,
	useUpdateErpLoadListQuantitiesMutation,
	useUpdateErpLoadListSessionItemAvailabilityMutation,
	useUpdateErpLoadListSessionNameMutation,
	useUpdateErpLoadListSessionRoutesMutation,
	useUpdateErpLoadListSessionShipDateMutation,
	useUpdateItemAttributesMutation,
	useUpdateItemMutation,
	useUpdateLineItemContextNoteMutation,
	useUpdateLineItemMutation,
	useUpdateLocationMutation,
	useUpdateMasterAcknowledgedQuantityMutation,
	useUpdateMasterLineItemMutation,
	useUpdateMasterOrderStatusMutation,
	useUpdateMasterSalesPersonMutation,
	useUpdateMaterialItemDetailsMutation,
	useUpdateOrderContactMutation,
	useUpdateOrderRouteMutation,
	useUpdateOrderSendInvoiceEmailsMutation,
	useUpdateOrderSendOrderEmailsMutation,
	useUpdateOrderStatusMutation,
	useUpdatePriceGroupMutation,
	useUpdatePriceLevelsMutation,
	useUpdatePortalSettingsMutation,
	useUpdateProductionCatalogMutation,
	useUpdateProductionItemMutation,
	useUpdateProductionLineMutation,
	useUpdateProductionLotAsyncImportJobRowsMutation,
	useUpdateProductionLotPlanMutation,
	useUpdateProductionMaterialEventDetailMutation,
	useUpdateProductionMaterialEventMutation,
	useUpdateProductionRecipeVariationFieldsMutation,
	useUpdateProductionRecipeVariationMutation,
	useUpdateProductionSpaceEventDetailMutation,
	useUpdateProductionSpaceEventMutation,
	useUpdateProductionTaskEventDetailMutation,
	useUpdateProductionTaskEventMutation,
	useUpdateProductionTriggerMutation,
	useUpdatePromotionRuleMutation,
	useUpdateReportMutation,
	useUpdateReportScheduleMutation,
	useUpdateSalesPersonMutation,
	useUpdateShippedQuantityMutation,
	useUpdateTaskEventTypeMutation,
	useUpdateTenantAutoAllocateExcludedGradesMutation,
	useUpdateTenantBrandingMutation,
	useUpdateTenantCompanyProfileMutation,
	useUpdateTenantGradeLabelsMutation,
	useUpdateTenantOrderEmailsEnabledMutation,
	useUpdateTenantSignInPanelMutation,
	useUpdateTermsMutation,
	useUpdateUserAppSettingMutation,
	useUpdateUserFullNameMutation,
	useUpdateUserRolesMutation,
	useUpdateWsapiImportEntityMappingMutation,
	useUpdateWsapiImportScheduleMutation,
	useUpsertBillingAddressesMutation,
	useUpsertContactsMutation,
	useUpsertLocationsMutation,
	useUpsertMergeCrmTenantIntegrationMutation,
	useUpsertMergeTenantIntegrationMutation,
	useUpsertMySqlTenantIntegrationMutation,
	useVoidInvoiceMutation,
	useWaiveInvoiceLateChargeMutation,
	useGrantParentCompanyTenantAccessMutation,
	useMyParentCompanyQuery,
	useRevokeParentCompanyTenantAccessMutation,
	useAcceptGrowerBenchmarkAcceptableUseMutation,
	useApproveGrowerBenchmarkReviewMutation,
	useBeginGrowerBenchmarkFirmLookupMutation,
	useGrowerBenchmarkUpsertMetricMutation,
	useGetGrowerBenchmarkBillingSummaryQuery,
	useGetGrowerBenchmarkCohortPassRunsQuery,
	useGetGrowerBenchmarkCohortStatisticsQuery,
	useGetGrowerBenchmarkFirmMetricsQuery,
	useGetGrowerBenchmarkMemberDirectoryQuery,
	useGetGrowerBenchmarkMetricCatalogQuery,
	useGetGrowerBenchmarkMyCommunitiesQuery,
	useGetGrowerBenchmarkMyFirmsQuery,
	useGetGrowerBenchmarkMyReviewQuery,
	useGetGrowerBenchmarkReportQueueQuery,
	useGetGrowerBenchmarkRetailMonthsQuery,
	useGetGrowerBenchmarkReviewMeteringQuery,
	useGetGrowerBenchmarkReviewQuery,
	useLazyGetGrowerBenchmarkAccessLogExportQuery,
	useLazyGetGrowerBenchmarkMyReviewPdfQuery,
	useOpenGrowerBenchmarkReviewForEditMutation,
	useReleaseGrowerBenchmarkReviewMutation,
	useRestoreGrowerBenchmarkReviewVersionMutation,
	useRevokeGrowerBenchmarkRosterEntryMutation,
	useSaveGrowerBenchmarkReviewVersionMutation,
	useSetGrowerBenchmarkFirmChecklistItemMutation,
	useSetGrowerBenchmarkFirmProfileMutation,
	useSetGrowerBenchmarkRetailMonthValuesMutation,
	useSetGrowerBenchmarkRosterEntryMutation
} = apiEndpoints;

// Re-export paginated hooks from injected endpoints
export const { useGetWsapiImportsQuery, useLazyGetWsapiImportsQuery } = wsapiImportApi;
export const { useGetGlAccountsQuery } = glAccountsPaginatedApi;
export const { useUploadOnboardingFileMutation } = onboardingUploadApi;

export const {
	useFernieQuickBooksLinksQuery,
	useFernieStripeTaxCodeCandidatesQuery,
	useRequestQuickBooksLinkJobMutation,
	useQuickBooksLinkJobQuery
} = apiEndpoints;
